import React, {useState} from "react";
import {useInstructors} from "../firebase/useInstructors";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import EmailIcon from "@mui/icons-material/Email";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";

export const EmailContent = () => {
    const [copied, setCopied] = useState(false);
    const instructors = useInstructors({
        orderBy: "name",
        order: "asc",
        forceRefresh: false,
    });

    const validInstructors = instructors?.filter(i => Boolean(i.email)) || [];
    const emailList = validInstructors.map(i => i.email.trim()).join(", ");

    const handleSendEmail = () => {
        if (validInstructors.length > 0) {
            window.open(`mailto:?bcc=${encodeURIComponent(validInstructors.map(i => i.email.trim()).join(","))}`);
        }
    };

    const handleCopyEmails = () => {
        if (emailList && navigator.clipboard) {
            navigator.clipboard.writeText(emailList).then(() => {
                setCopied(true);
            });
        }
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
                <Chip
                    label={`${validInstructors.length} kursholdere med registrert e-post`}
                    color="primary"
                    variant="outlined"
                    sx={{ fontWeight: 600 }}
                />
            </Box>

            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                Du kan enten åpne e-postprogrammet ditt direkte hvor alle adressene legges automatisk i blindkopi (BCC), eller kopiere alle adressene for å lime dem inn i for eksempel Gmail, Outlook i nettleseren eller et nyhetsbrevverktøy.
            </Typography>

            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ pt: 1 }}>
                <Button
                    onClick={handleSendEmail}
                    variant="contained"
                    color="primary"
                    startIcon={<EmailIcon />}
                    disabled={validInstructors.length === 0}
                    sx={{
                        textTransform: "none",
                        fontWeight: 700,
                        borderRadius: 2.5,
                        px: 3,
                        py: 1.25,
                    }}
                >
                    Åpne i e-postprogram (BCC)
                </Button>

                <Button
                    onClick={handleCopyEmails}
                    variant="outlined"
                    color="primary"
                    startIcon={copied ? <CheckIcon /> : <ContentCopyIcon />}
                    disabled={validInstructors.length === 0}
                    sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        borderRadius: 2.5,
                        px: 3,
                        py: 1.25,
                    }}
                >
                    {copied ? "Kopiert til utklippstavlen" : "Kopier alle e-poster"}
                </Button>
            </Stack>

            <Snackbar
                open={copied}
                autoHideDuration={4000}
                onClose={() => setCopied(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert severity="success" sx={{ width: "100%", borderRadius: 2 }}>
                    {validInstructors.length} e-postadresser ble kopiert til utklippstavlen!
                </Alert>
            </Snackbar>
        </Box>
    );
};